<template>
	<section class="blank-container">
		<div class="logo-header-container">
			<img class="logo-header" src="@/assets/buzzztv_logo.png" alt="BuzzzTV" />
		</div>
		<slot />
	</section>
</template>

<script>
export default {
	name: 'AuthShell',
	created() {
		this.$store.commit({ type: 'toggleBlankMode', value: true })
	},
	destroyed() {
		this.$store.commit({ type: 'toggleBlankMode', value: false })
	}
}
</script>

<style lang="scss" scoped>
.blank-container {
	margin: 5% auto;
	max-width: 500px;
	width: 100%;
	box-sizing: border-box;

	.logo-header-container {
		width: 25%;
		margin: auto;
	}

	.logo-header {
		display: block;
		width: 100%;
		max-height: 100%;
		height: auto;
	}
}
</style>
